import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation(['newsletter']);
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form reload

    if (!email) {
      setMessage('Please enter an email.');
      return;
    }
    if (submitting) {
      setMessage('Already submitting, please wait...');
      return;
    }

    try {
      setSubmitting(true);
      // Get public IP
      const ipRes = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipRes.json();
      const ipAddress = ipData.ip;
      console.log('User IP:', ipAddress); // Log the IP for debugging

      const response = await fetch('https://api.dev.adcast.app/newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, ipAddress })
      });

      const data = await response.json();
      if (response.ok) {
        setMessage('✅ Subscribed successfully!');
        setEmail('');
            toast('Subscribed successfully!', {
              className: 'auto-width-toast success-toast'
            });
      } else {
        setMessage(`❌ ${data.error || 'Something went wrong'}`);
        toast(`${data.error || 'Something went wrong'}`, {
          className: 'auto-width-toast error-toast'
        });
      }
    } catch (err) {
      console.error('Error:', err);
      setMessage('❌ Server error. Try again later.');
      toast('Server error. Try again later.', {
        className: 'auto-width-toast error-toast',
      });
    } finally {
      setTimeout(() => {
        setMessage(null);
        setSubmitting(false);
      }, 2000); // Clear message after 5 seconds
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="email"
        placeholder={t('newsletter:emailAdresa')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button type="submit" className="submit_btn" disabled={submitting}>
        {submitting ? t('newsletter:subscribing') : t('newsletter:subscribe')}
      </button>
    </form>
  );
};

export default NewsletterForm;
